<template>
  <div class="ads-cards-container">
    <div v-for="(adsCard,index) in adsCardData" v-bind:key="index" class="ads-performance-card">
      <div class="label-card-header">{{(adsCard.key)}}</div>
      <h3>{{(transformUnit(adsCard.value))}}</h3>
    </div>
  </div>
</template>

<script>
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  props: ['adsCardData'],
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/section.scss';

.label-card-header {
  color: $gray-600;
  font-size: $font-size-base;
  text-align: left;
  text-transform: uppercase;
}

h3 {
  color: $gray-800;
  font-size: $font-size-lg * 1.25;
  text-align: left;
}

.ads-cards-container {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  .ads-performance-card {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex: 1 0 40%;
    max-height: 70px;
    text-align: center;
    margin: $spacer;
    padding: $spacer / 2;
  }
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .ads-cards-container {
    .ads-performance-card {
      padding: 0;
      margin: $spacer / 2 $spacer;
    }
  }

  h3 {
    color: $gray-800;
    font-size: $font-size-lg;
    text-align: left;
  }

  .label-card-header {
    font-size: $font-size-base * 0.875;
  }
}

@media (min-width: 1301px) and (max-width: 1600px) {
}
</style>
